<template>
  <div class="redirect-container">
    <img
      src="https://console.fanaty.com/img/logo-2.269da70f.png"
      alt="Fanaty"
      class="logo"
    />
    <div class="spinner" />
    <span class="text">Abriendo Fanaty...</span>
  </div>
</template>

<script>
export default {
  name: 'DeepLinkRedirect',

  created() {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
    const isAndroid = /android/i.test(ua)

    // Leer el deep link del query param (ej: ?deepLink=/l/r/141778)
    // Limpiar parámetros fbclid que Instagram agrega automáticamente
    let { deepLink } = this.$route.query
    if (deepLink) {
      const [cleanPath] = deepLink.split('?') // Remover query params (fbclid, etc.)
      deepLink = cleanPath
    }
    const deepLinkUrl = deepLink
      ? `https://app.fanaty.com${deepLink}`
      : 'https://app.fanaty.com'

    if (isAndroid) {
      // En Chrome, intent:// funciona correctamente con browser_fallback_url
      const path = deepLinkUrl.replace(/^https?:\/\//, '')
      const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.fanaty'
      const fallback = encodeURIComponent(playStoreUrl)
      const intentUrl = `intent://${path}#Intent;scheme=https;package=com.fanaty;S.browser_fallback_url=${fallback};end`

      window.location.href = intentUrl

      // Fallback: si la app no está instalada y browser_fallback_url no se activa,
      // después de 2s redirigir al Play Store
      setTimeout(() => {
        window.location.href = playStoreUrl
      }, 2000)
    } else if (isIOS) {
      // En Safari, intentar abrir la app via Universal Link
      window.location.href = deepLinkUrl

      // Si la app no está instalada, después de 2s ir al App Store
      setTimeout(() => {
        window.location.href = 'itms-apps://apps.apple.com/us/app/fanaty/id1461051554'
      }, 2000)
    } else {
      // Desktop: ir a la web
      window.location.href = 'https://www.fanaty.com/'
    }
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.redirect-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #0a0a14;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  gap: 20px;
}

.logo {
  width: 80px;
  object-fit: contain;
  opacity: 0.9;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.text {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.3px;
}
</style>
